<div
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="100"
  (scrolled)="onScroll()"
  [scrollWindow]="false"
  class="infinite-scroll"
>
  <cc-form-card
    *ngFor="let form of forms"
    class="d-block m-3"
    [form]="form"
    [template]="template"
    [routerLink]="[form._id]"
    queryParamsHandling="merge"
  ></cc-form-card>
</div>
<span
  class="cc-icon loading-icon cc-icon-spinner-3x"
  [class.small-loading]="forms.length"
  [class.big-loading]="!forms.length"
  *ngIf="loading"
></span>
